module.exports = __webpack_public_path__ + "static/media/undraw_queue_qt30.2b2fc0ef.svg";